<template>
  <div class="row">
    <h1 class="m-b-md">{{ $t('guides.documentation') }}</h1>

    <div v-show="loading" class="text-center w-100">
      <div class="spinner-border" style="height: 4rem; width: 4rem" role="status">
        <span class="visually-hidden">{{ $t('events.loading') }}...</span>
      </div>
    </div>

    <div
      v-show="!loading"
      class="pdf-container"
      ref="pdfContainer"
      @contextmenu.prevent
    ></div>
  </div>
</template>

<script>
import axios from 'axios';
import authHeader from '../../services/auth-header';
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf.js';
import 'pdfjs-dist/legacy/build/pdf.worker.entry';

export default {
  name: 'Documentation',
  data() {
    return { 
      loading: false 
    }
  },
  mounted() {
    this.loadPdf();
    window.addEventListener('keydown', this.blockShortcuts);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.blockShortcuts);
  },
  methods: {
    async loadPdf() {
      this.loading = true;
      try {
        const response = await axios.get(
          'https://api.varsanpr.com/api/documents/help/guides',
          { headers: authHeader(), responseType: 'blob' }
        );

        const pdfData = await response.data.arrayBuffer();
        const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;

        this.loading = false;
        await this.$nextTick();
        
        await new Promise(resolve => setTimeout(resolve, 100));

        const container = this.$refs.pdfContainer;
        container.innerHTML = '';

        const containerWidth = container.clientWidth;
        

        for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
          const page = await pdf.getPage(pageNum);

          const viewport = page.getViewport({ scale: 1 });
          const scale = (containerWidth - 40) / viewport.width;
          const scaledViewport = page.getViewport({ scale });

          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          canvas.width = scaledViewport.width;
          canvas.height = scaledViewport.height;
          canvas.className = 'pdf-page';

          await page.render({ canvasContext: ctx, viewport: scaledViewport }).promise;
          container.appendChild(canvas);
        }
      } catch (err) {
        console.error('Failed to load PDF', err);
        this.$error('Error retrieving help guides.');
      }
    },
    blockShortcuts(e) {
      if ((e.ctrlKey || e.metaKey) && ['s', 'p'].includes(e.key.toLowerCase())) {
        e.preventDefault();
      }
    },
  },
}
</script>

<style scoped>
.row {
  display: block;
  width: 100%;
}

.pdf-container {
  width: 100%;
  max-width: 100%;
  height: 80vh;
  overflow-y: auto;
  overflow-x: hidden;
  background: #f5f5f5;
  padding: 20px;
  box-sizing: border-box;
  position: relative;
}

.pdf-page {
  display: block;
  margin: 0 auto 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  background: white;
  user-select: none;
  max-width: 100%;
  height: auto;
  width: auto !important;
}

.pdf-container * {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
</style>